// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/save_experiment_as_response.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentData } from "./experiment_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_data } from "./experiment_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/save_experiment_as_response.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_response: GenFile = /*@__PURE__*/
  fileDesc("CklxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvc2F2ZV9leHBlcmltZW50X2FzX3Jlc3BvbnNlLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEihQEKGFNhdmVFeHBlcmltZW50QXNSZXNwb25zZRJVCg9leHBlcmltZW50X2RhdGEYASABKAsyNy5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuRXhwZXJpbWVudERhdGFIAIgBAUISChBfZXhwZXJpbWVudF9kYXRhYgZwcm90bzM", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_data]);

/**
 * Rpc response containing saved experiment data
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.SaveExperimentAsResponse
 */
export type SaveExperimentAsResponse = Message<"quanterix.simoa_one.analysis_app_api.v1.SaveExperimentAsResponse"> & {
  /**
   * Saved experiment data
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentData experiment_data = 1;
   */
  experimentData?: ExperimentData;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.SaveExperimentAsResponse.
 * Use `create(SaveExperimentAsResponseSchema)` to create a new message.
 */
export const SaveExperimentAsResponseSchema: GenMessage<SaveExperimentAsResponse> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_response, 0);

